import { checkToken } from './common/api'
import { elements, getSelectedItems, initElements, removeAvailableFileElement, secureCall, setupElements } from './common/elements'
import { getAndInsertParagraphs } from './common/get-and-insert-paragraphs'
import { deleteFiles, getLS, LS_KEYS, removeAvailableFiles, resetSavedFiles, saveSettings, updateIsAI } from './common/ls'
import { parseTables } from './common/parse-tables'
import { Filename } from './common/types'
import { uploadRTF } from './common/upload-rtf'
import { showErrors } from './open-error-modal'
import { openModal } from './open-modal'

Office.onReady((info) => {
    if (info.host === Office.HostType.Word) {
        OfficeExtension.config.extendedErrorLogging = true
        Word.run(async (context) => {
            const tryCatch = (f: (context, window) => any) => {
                secureCall(f, context, null)
                context.sync()
            }
            tryCatch(() => {
                initElements()
                setupElements()

                //if (elements.run)
                    //elements.run.onclick             = () => tryCatch(pushToDb)
                if (elements.get)
                    elements.get.onclick             = () => tryCatch(getAndInsertParagraphs)
                if (elements.parseTables)
                    elements.parseTables.onclick     = () => tryCatch(parseTables)
                if (elements.settings)
                    elements.settings.onclick        = () => tryCatch(saveSettings)
                if (elements.uploadRTF)
                    elements.uploadRTF.onchange      = () => tryCatch(uploadRTF)
                if (elements.openModal)
                    elements.openModal.onclick       = () => tryCatch((context, window) => {
                        const files = getSelectedItems(elements.availableFiles) as Array<Filename>
                        openModal(context, window, {
                            files: files.length ? files : getLS(LS_KEYS.lastUploadedFiles),
                            inited: true,
                        })
                    })
                if (elements.deleteFiles)
                    elements.deleteFiles.onclick     = () => tryCatch((context, window) => {
                        const files = getSelectedItems(elements.availableFiles) as Array<Filename>
                        deleteFiles(files)
                    })
                if (elements.resetSavedFiles)
                    elements.resetSavedFiles.onclick = () => tryCatch(resetSavedFiles)
                if (elements.useAI)
                    elements.useAI.onchange = () => tryCatch(() => updateIsAI(elements.useAI.checked))
                if (elements.authKey)
                    elements.authKey.onchange = () => tryCatch(() => saveSettings())
                const check = () => {
                    if (!elements.tflImportPe) return
                    elements.tflImportPe.removeAttribute('style')
                    checkToken().then(() => {
                        elements.tflImportAd.setAttribute('style', 'display: none;')
                        elements.tflImportOk.removeAttribute('style')
                    }).catch(() => {
                        elements.tflImportOk.setAttribute('style', 'display: none;')
                        elements.tflImportAd.removeAttribute('style')
                    }).finally(() => {
                        elements.tflImportPe.setAttribute('style', 'display: none;')
                    })
                }
                check()
                if (elements.checkToken) 
                    elements.checkToken.onclick = () => tryCatch(() => check())

                if (elements.errorButton) {
                    elements.errorButton.onclick = () => tryCatch((context, window) => {
                        showErrors(context, window, ['Test', 'Error', 'Message?'])
                    })
                }
            })
            await context.sync()
        })
    }
})

export async function run() {
    return Word.run(async (context) => {
        await context.sync()
    })
}
